import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Block } from '@core/models/block/block.model';

@Component({
  selector: '[app-heading]',
  template: `
    <ng-container [ngSwitch]="tagName">
      <h1 *ngSwitchCase="'h1'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h1>
      <h2 *ngSwitchCase="'h2'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h2>
      <h3 *ngSwitchCase="'h3'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h3>
      <h4 *ngSwitchCase="'h4'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h4>
      <h5 *ngSwitchCase="'h5'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h5>
      <h6 *ngSwitchCase="'h6'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></h6>
      <p *ngSwitchCase="'p'" [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></p>
      <span *ngSwitchDefault [attr.tabindex]="tabIndex" [innerHTML]="renderedContent"></span>
    </ng-container>
  `,
  encapsulation: ViewEncapsulation.None,
  imports: [
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
  ],
})
export class HeadingBlockComponent implements OnChanges {
  renderedContent: SafeHtml = '';

  private _content: SafeHtml;
  private _item: Block;

  get content(): SafeHtml {
    return this._content;
  }

  @Input() set content(val: SafeHtml) {
    this._content = val;
    this.update();
  }

  get item(): Block {
    return this._item;
  }

  @Input() set item(block: Block) {
    this._item = block;
    this.update();
  }

  get tabIndex(): number {
    return this.item?.tabIndex;
  }

  get tagName(): string {
    return this.item?.settings?.tagName;
  }

  private update(): void {
    if (!this._item || !this._content) {
      return;
    }

    const {action, modelId, node} = this._item;

    if (modelId > 0 && action?.actionRequestForModel?.id && action.actionRequestForModel?.className.includes('InventoryWork')) {
      this.renderedContent = `${this._content}<div class="node${node}"></div>`;
    } else {
      this.renderedContent = this._content;
    }
  }

  ngOnChanges(): void {
    this.update();
  }
}
